




















import { defineComponent, computed } from '@vue/composition-api';
import GongyiCard from '../common/gongyi-card.vue';
import HonoraryItem from './item.vue';
import { getHonoraryList } from '@/hooks/use-honorary';
import { HonoraryLevelConfig } from '@/config/index';

export default defineComponent({
  name: 'HonoraryModule',
  components: { GongyiCard, HonoraryItem },
  props: {
    /** 捐贈印花数 */
    donateCount: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { donateCount } = props;
    const honoraryList = getHonoraryList();
    /**
     * 转换荣誉配置信息
     */
    const parseHonoraryData = (config: HonoraryLevelConfig) => {
      const { level, target, nickName, icon } = config;
      const index = honoraryList.indexOf(config);
      const prev = honoraryList[index - 1];
      const next = honoraryList[index + 1];
      return {
        level,
        target,
        nickName,
        // 是否完成该荣誉等级
        completed: donateCount >= target,
        // 是否完成该荣誉等级
        isPrevCompleted: prev && donateCount >= prev.target,
        // 是否还有下一个荣誉等级
        hasNext: !!next,
        icon,
      };
    };
    const list = computed(() => honoraryList.map((item) => parseHonoraryData(item)));
    return {
      list,
    };
  },
});
